import { URI } from '@/config/config';

export default async ({ commit, rootState }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    }
  };

  try {
    await fetch(`${URI}user/employee-logout`, opts);
    commit('DATA-ACCESS/setUserToken', null, { root: true });
  } catch (error) {
    console.error(error);
  }
};
